import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=6aff5140&"
import script from "./grid.vue?vue&type=script&lang=ts&"
export * from "./grid.vue?vue&type=script&lang=ts&"
import style0 from "./grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports